import { registerPrimeVueConfirmation } from '@/plugins/primevue-confirmation'
import { registerPrimeVueToast } from '@/plugins/primevue-toast'
import type { App } from 'vue'

import { registerCron } from './cron-light'
import { registerPinia } from './pinia'
import { registerRoutes } from './router'
import { registerVueI18n } from './vue-i18n'

export function registerPlugins(app: App) {
  registerRoutes(app)
  registerVueI18n(app)
  registerPrimeVueToast(app)
  registerPinia(app)
  registerPrimeVueConfirmation(app)
  registerCron(app)
}
